import { NgModule } from '@angular/core';
import { GCCoreModule } from '@core/_core.module';
import { RuleAutomationModule } from '@features/rule-automation/rule-automation.module';
import { CreateEditRulePageComponent } from './create-edit-rule-page/create-edit-rule-page.component';
import { RerouteApplicationModalComponent } from './reroute-application-modal/reroute-application-modal.component';
import { ViewHistoryPageComponent } from './view-history-page/view-history-page.component';
import { ViewRulesPageComponent } from './view-rules-page/view-rules-page.component';
import { WorkflowAutomationViewWrapperComponent } from './workflow-automation-view-wrapper/workflow-automation-view-wrapper.component';

@NgModule({
  imports: [
    RuleAutomationModule,
    GCCoreModule
  ],
  declarations: [
    RerouteApplicationModalComponent,
    CreateEditRulePageComponent,
    ViewRulesPageComponent,
    WorkflowAutomationViewWrapperComponent,
    ViewHistoryPageComponent
  ]
})
export class WorkflowAutomationModule {

}
